// msalFactory.js
import { PublicClientApplication } from "@azure/msal-browser";

const instanceCache = new Map();   // tenantId|clientId -> msal instance
const readyCache = new Map();      // tenantId|clientId -> initialize() promise

const getCacheKey = (clientId, tenantId) => `${tenantId ?? "common"}|${clientId}`;

export async function getMsal(clientId,tenantId) {
  const authority = `https://login.microsoftonline.com/${tenantId}`;
  if (!clientId) throw new Error("Missing MSAL clientId");
  const cacheKey = getCacheKey(clientId, tenantId);

  // If we've already created & initialized this clientId, return it.
  if (instanceCache.has(cacheKey) && readyCache.has(cacheKey)) {
    await readyCache.get(cacheKey);
    return instanceCache.get(cacheKey);
  }

  // Build (or reuse) the instance
  let app = instanceCache.get(cacheKey);
  if (!app) {
    app = new PublicClientApplication({
      auth: { 
        clientId, 
        authority,
        redirectUri: window.location.origin +"/reports",   // must be registered as SPA redirect
        postLogoutRedirectUri: window.location.origin+"/reports"
    },
      cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: true },
      system: { allowRedirectInIframe: true }  // optional if you ever use redirect inside iframes
    });
    instanceCache.set(cacheKey, app);
  }

  // Initialize once per tenant/client pair
  if (!readyCache.has(cacheKey)) {
    const initPromise = app.initialize().then(async () => {
      try {
        const redirectResult = await app.handleRedirectPromise();
        if (redirectResult?.account) {
          app.setActiveAccount(redirectResult.account);
        }
      } catch {
        // Popup flow is primary here; swallow redirect processing failures.
      }

      if (!app.getActiveAccount()) {
        const [firstAccount] = app.getAllAccounts();
        if (firstAccount) {
          app.setActiveAccount(firstAccount);
        }
      }
    });
    readyCache.set(cacheKey, initPromise);
  }

  await readyCache.get(cacheKey);
  return app;
}
